module.exports = __webpack_public_path__ + "img/cjjyl-app.c81fccdf.png";